import { enableProdMode, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor, ErrorInterceptor, AuthGuard, fakeBackendProvider } from './app/core/interceptors';
import { AuthService } from './app/features/auth/_services/auth.service';
import { FirebaseService } from './app/core/services/firebase.service';
import { BLOB_STORAGE_TOKEN, azureBlobStorageFactory } from './app/features/auth/azure-storage/services/token';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { HomeComponent } from './app/features/home/home.component';
import { LoginComponent } from './app/features/auth/login.component';
import { RegisterComponent } from './app/features/auth/register.component';
import { ForgotPasswordComponent } from './app/features/auth/forgot-password.component';
import { VerifyEmailComponent } from './app/features/auth/verify-email.component';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(), importProvidersFrom(BrowserModule),
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        AuthGuard,
        AuthService,
        // provider used to create fake backend
        fakeBackendProvider, FirebaseService,
        { provide: BLOB_STORAGE_TOKEN, useFactory: azureBlobStorageFactory },
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideFirestore(() => getFirestore()),
        provideAuth(() => getAuth()),
        provideStorage(() => getStorage()),
        provideAnimations(),
        provideRouter([
            { path: 'home', component: HomeComponent },
            { path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'fullmenu', loadChildren: () => import("./app/features/menu/menu.routes").then(m => m.MENU_ROUTES) },
            {
                path: 'contact',
                loadChildren: () => import("./app/features/contact/contact-us.routes").then(m => m.CONTACT_ROUTES)
            },
            {
                path: 'booking',
                loadChildren: () => import("./app/features/reservations/book-table.routes").then(m => m.BOOK_TABLE_ROUTES)
            },
            { path: 'member', loadChildren: () => import("./app/features/account/member.routes").then(m => m.MEMBER_ROUTES) },
            { path: 'login', component: LoginComponent },
            { path: 'register', component: RegisterComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: 'verify-email-address', component: VerifyEmailComponent },
            { path: 'admin', loadChildren: () => import("./app/features/admin/admin.routes").then(m => m.ADMIN_ROUTES) },
            { path: '**', component: HomeComponent }
        ])
    ]
})
  .catch(err => console.error(err));
